import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Dialog from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Dialog';
import {
  ComposeMessage,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ComposeMessage/ComposeMessage';

const useStyles = buildUseStyles('ComposeMessageDialog', () => ({
  root: {},
}));

const ComposeMessageDialog = ({
  className,
  title,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const TitleComponent = () => title; // <--- Action bar coming from the docked dialog item

  return (
    <Dialog
      open
      maxWidth="xxl"
      className={classNames(classes.root, className)}
    >
      <TitleComponent />
      <ComposeMessage />
    </Dialog>
  );
};

ComposeMessageDialog.defaultProps = {
  className: '',
};

ComposeMessageDialog.propTypes = {
  className: PropTypes.string,
  title: PropTypes.node.isRequired,
};

export { ComposeMessageDialog };
